export default "__VITE_ASSET__w92_voXJ__"